<template>
  <div class="home-container">
    <div class="home-content" v-if="recordFlag == 'voteList'">
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
      </div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="id" label="id" align="center">
        </el-table-column>
        <el-table-column prop="title" label="活动标题" align="center">
        </el-table-column>        
        <el-table-column prop="img" label="活动图片" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.img" min-width="70" height="70" />
          </template>
        </el-table-column>
        <el-table-column prop="totalRestrict" label="总限制次数" align="center">
        </el-table-column>    
        <el-table-column prop="dayRestrict" label="每天限制次数" align="center">
        </el-table-column>     
        <el-table-column prop="startTime" label="	活动开始时间" align="center">
        </el-table-column> 
        <el-table-column prop="endTime" label="	活动结束时间" align="center">
        </el-table-column>                                      
        <el-table-column prop="status" label="活动状态" align="center" :formatter="siteType">
        </el-table-column>
        <el-table-column prop="isRecommend" label="是否推荐" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isRecommend"
              @change="updataStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>   
        <el-table-column prop="isOpen" label="是否公开" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isOpen"
              @change="openStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>          
        <el-table-column  label="问题列表" align="center">
          <template slot-scope="scope">
            <a href="#" @click="bindProblem(scope.row.id)">问题列表</a>
          </template>
        </el-table-column>          
        <el-table-column  label="活动记录" align="center">
          <template slot-scope="scope">
            <a href="#" @click="bindRecord(scope.row.id)">活动记录</a>
          </template>
        </el-table-column>             
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="sendNotice(scope.row)"
              >发送通知</el-button
            >              
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="50%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="活动图片" prop="img">
                <upload
                  :url.sync="addData.img"
                  :src="addData.img"
                  type="img"
                  :width="220"
                  :height="160"
                ></upload>
                <div style="color: red">*(建议尺寸220px * 160px)）</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="活动标题" prop="title">
                <el-input
                  v-model="addData.title"
                  placeholder="请输入活动标题"
                ></el-input>
              </el-form-item> 
            </el-col>          
          </el-row>     
          <el-row>
            <el-col :span="12">
              <el-form-item label="总限制次数" prop="totalRestrict" label-width="100px">
                <el-input
                  v-model="addData.totalRestrict"
                  placeholder="请输入总限制次数"
                ></el-input>
              </el-form-item> 
            </el-col>
            <el-col :span="12">
              <el-form-item label="日限制次数" prop="dayRestrict" label-width="100px">
                <el-input
                  v-model="addData.dayRestrict"
                  placeholder="请输入每日限制次数"
                ></el-input>
              </el-form-item> 
            </el-col>            
          </el-row>   
          <el-row>
            <el-col :span="12">
              <el-form-item label="开始时间" prop="startTime">
                <el-date-picker
                  v-model="addData.startTime"
                  type="datetime"
                  placeholder="选择开始日期">
                </el-date-picker>
              </el-form-item> 
            </el-col>   
            <el-col :span="12">
              <el-form-item label="结束时间" prop="endTime">
                <el-date-picker
                  v-model="addData.endTime"
                  type="datetime"
                  placeholder="选择开始日期">
                </el-date-picker>
              </el-form-item> 
            </el-col>                    
          </el-row> 
          <el-row>
            <el-form-item label="活动内容" prop="content">
              <ueditor v-model="addData.content"></ueditor>
            </el-form-item>
          </el-row>                                            
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <send :index="2" @sendSubmit="sendSubmit" @isShowSend="sendFlags = false" v-if="sendFlags"></send>    
    <div class="home-content" v-if="recordFlag == 'voteRecord'">
      <voterecordlist :questionnaireId="questionnaireId" @recordBack="recordBack"></voterecordlist>
    </div>
    <div class="home-content" v-if="recordFlag == 'voteAnswer'">
      <answerList :questionnaireId="questionnaireId" @answerBack="answerBack"></answerList>
    </div>    
  </div>
</template>

<script>
import upload from "../../components/upload";
import ueditor from "../../components/ueditor";
import reg from "../../utils/reg"
import voterecordlist from "./questionnaireRecord.vue"
import answerList from "./questionnaireAnswer.vue"
import send from "../../components/send"
export default {
  components: {
    upload,
    ueditor,
    voterecordlist,
    answerList,
    send
  },
  data() {
    return {
      searchForm: {
        site: "",
      },
      checkedStr: [], //选中的名称
      checkedIds: [], //选中的id
      isShowTrue: false, //是否显示二级树
      defaultProps: {
        children: "children",
        value: "id",
        label: "name",
      },
      houseFlag: true,
      modalTitle: "新增",
      props: {
        multiple: true,
        value: "id",
        label: "name",
        checkStrictly: true,
      },
      villageList:[{
          id:1,
          name:'单选'
        },{
          id:2,
          name:'多选'
        },
      ],
      muneListData: [], //菜单信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        id: "",
        img: "",
        title: "",
        totalRestrict: "",
        dayRestrict: "",
        startTime: "",
        endTime: "",
        status: "",
        isRecommend:'',
        isOpen:''
      },
      addDataRules: {
        // img: [{ required: true, message: "请上传活动图片", trigger: "blur" }],
        title: [{ required: true, message: "请输入活动标题", trigger: "blur" }],
        totalRestrict: [{ required: true, message: "请输入总限制次数", trigger: "blur" }],
        dayRestrict: [{ required: true, message: "请输入每天限制次数", trigger: "blur" }],
        startTime: [{ required: true, message: "请选择活动开始时间", trigger: "blur" }],
        endTime: [{ required: true, message: "请选择活动结束时间", trigger: "blur" }],
        content: [{ required: true, message: "请输入活动内容", trigger: "blur" }],
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
      questionnaireId:'',
      recordFlag:'voteList',
      sendFlags:false,  
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    sendSubmit(data){
      data.entityId = this.orderId
      this.$Apis.sendQuestionnaire(data).then(res=>{
        if(res.code == 200){
          this.$message.success('发送成功')
          this.sendFlags = false 
        }else{
          this.$message.warning(res.code)
        }
      })
    },
    sendNotice(row){
      this.orderId = row.id
      this.sendFlags = true
    },    
    // 问题列表返回
    answerBack(){
      this.recordFlag = 'voteList'
    },
    // 问题列表
    bindProblem(row){
      this.questionnaireId = row
      this.recordFlag = 'voteAnswer'
    },
    // 投票纪录返回
    recordBack(){
      this.recordFlag = 'voteList'
    },
    // 投票记录
    bindRecord(row){
      this.questionnaireId = row
      this.recordFlag = 'voteRecord'
    },
    // 活动状态
    siteType(row){
      if(row.status == 1){
        return '未开始'
      }else if(row.status == 2){
        return '进行中'
      }else if(row.status == 3){
        return '已结束'
      }
    },
    // 是否推荐
    updataStatus(row) {
      let data = {
        id:row.id,
        img: row.img,
        title: row.title,
        totalRestrict: row.totalRestrict,
        dayRestrict: row.dayRestrict,
        startTime: row.startTime,
        endTime: row.endTime,
        content: row.content,    
        isRecommend:row.isRecommend == true ? 1 : -1,    
        isOpen:row.isOpen == true ? 1 : -1
      }
      this.$Apis.questionnaireAddUp(data).then((res) => {
        if (res.code == 200) {
          this.onLoad();
          this.$message.success("操作成功");
        } else {
          this.$message.warning(res.msg);
        }
      });
    },  
    // 是否公开
    openStatus(row) {
      let data = {
        id:row.id,
        img: row.img,
        title: row.title,
        totalRestrict: row.totalRestrict,
        dayRestrict: row.dayRestrict,
        startTime: row.startTime,
        endTime: row.endTime,
        content: row.content,    
        isRecommend:row.isRecommend == true ? 1 : -1,    
        isOpen:row.isOpen == true ? 1 : -1
      }
      this.$Apis.questionnaireAddUp(data).then((res) => {
        if (res.code == 200) {
          this.onLoad();
          this.$message.success("操作成功");
        } else {
          this.$message.warning(res.msg);
        }
      });
    },       
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 新增
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.modalTitle = "新增"; 
      this.isAddModal = true;
    },
    // 修改
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.isAddModal = true;
    },
    //删除
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.questionnaireDel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            id: this.addData.id || "",
            img: this.addData.img,
            title: this.addData.title,
            totalRestrict: Number(this.addData.totalRestrict) ,
            dayRestrict: Number(this.addData.dayRestrict) ,
            startTime: reg.filterTime(this.addData.startTime),
            endTime: reg.filterTime(this.addData.endTime),
            content: this.addData.content,
          };
          if(data.totalRestrict < data.dayRestrict){
            this.$message.warning('总限制次数必须大于日限制次数')
            return
          }
          this.$Apis.questionnaireAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad()
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad()
    },
    onLoad() {
      // this.isShowloading = true;
      let page = {
        size: this.pageSize,
        current: this.currentPage,
      };
      this.$Apis.questionnaireList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item) => {
            item.isOpen = item.isOpen == 1 ? true : false;
            item.isRecommend = item.isRecommend == 1 ? true : false;
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
</style>